import React from "react";

// components
import UserSubscriberContext from "../../../context/UserSubscriberContext";

// game
import * as Level1 from './Levels/Level1.json';
import Player from "./Player";
import Platform from "./Platform";
import CheckPoint from "./CheckPoint";
import Button from "@mui/joy/Button";
import Box from "@mui/joy/Box";


class Platformer extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            started: false
        };
        this.keys = {
            right: false,
            left: false,
            up: false,
        };
        this.gravity = 0.9;
        this.level = Level1
    }

    updateKey(key, isPressed) {
        switch (key) {
            case "ArrowLeft":
                this.keys.left = isPressed;
                break;
            case "ArrowUp":
            case " ":
            case "Spacebar":
                this.keys.up = isPressed;
                break;
            case "ArrowRight":
                this.keys.right = isPressed;
        }
    };

    start(){
        this.canvas = document.getElementById('canvas');
        this.ctx = this.canvas.getContext("2d");
        this.platforms = this.level.platforms.map(({ x, y }) => new Platform(x, y, 200, 50, this));
        this.checkpoints = this.level.checkpoints.map(({ x, y }) => new CheckPoint(x, y, 20, 20, this));
        this.isActive = true
        this.margin = {
            left: this.canvas.width / 4,
            right: this.canvas.width / 4,
            top: 10,
            bottom: 10,
        };
        this.player = new Player(0, 0, 20, 20, this)
        this.setState({started: true}, this.animate)

    }

    isGameActive(){
        return this.checkpoints.length > 0
    }

    animate() {
        requestAnimationFrame(this.animate.bind(this));
        if (this.canvas){
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.player.move();
            this.player.evaluateCheckpoints();
            this.player.draw();
            this.platforms.forEach((platform) => {
                platform.draw();
            });
            this.checkpoints.forEach((checkpoint) => {
                checkpoint.draw();
            });
        }
    };

    componentDidMount() {
        window.addEventListener("keydown", ({key}) => {
            this.updateKey(key, true);
        });
        window.addEventListener("keyup", ({key}) => {
            this.updateKey(key, false);
        });
    }

    componentWillUnmount() {

    }

    render() {
        return(
            <Box
                sx={{
                    width: '100%',
                    display: 'block',
                }}
            >
                <canvas
                    id={'canvas'}
                    width={800}
                    height={600}
                >
                </canvas>
                {
                    !this.state.started?
                        <Button
                            onClick={this.start.bind(this)}
                        >
                            Начать
                        </Button>:
                        null
                }

            </Box>
        )
    }
}

export default Platformer